<template>
  <div class="container">
    <Burger
      class="menubtn"
      :menuopen="menuOpen"
      @togglemenu="menuOpen = !menuOpen"
    />
    <div
      class="menu"
      :class="{
        nowidth: !menuOpen,
      }"
    >
      <!-- <div class="topspacer"></div> -->
      <div class="leftborder"></div>
      <div class="navholder">
        <nav
          :class="{ disappear: hidewords, fadein: fadein, reallygone: hideall }"
        >
          <h1 @click="goto('welcome')">Matt Franklin</h1>
          <h2 @click="goto('mission')">Mission</h2>
          <h2 @click="goto('career')">Career</h2>
          <h2 @click="goto('education')">Education</h2>
          <!-- <h2 @click="goto('projects')">Projects</h2> -->
          <h2 @click="goto('contact')">Contact</h2>
        </nav>
      </div>
    </div>
    <div
      class="shadow"
      :class="{ reallygone: !menuOpen }"
      @click="menuOpen = false"
    ></div>
  </div>
</template>

<script>
import Burger from "./Burger";
export default {
  name: "Menu",
  components: {
    Burger,
  },
  data: function () {
    return {
      menuOpen: false,
      aborted: false,
      fadein: false,
      hideall: true,
      hidewords: true,
    };
  },
  watch: {
    menuOpen: function () {
      if (this.menuOpen) {
        this.fadein = true;
        setTimeout(() => {
          this.hideall = false;
          this.hidewords = false;
        }, 250);
        setTimeout(this.cancelfade, 500);
      } else {
        this.hideall = true;
        this.hidewords = true;
      }
    },
  },
  methods: {
    cancelfade: function () {
      this.fadein = false;
    },
    goto: function (dest) {
      // const scrollsave = document.getElementById("home").scrollTop;
      // history.pushState(null, null, "/");
      // history.pushState(null, null, "#" + dest);
      this.menuOpen = false;
      this.$emit("goto", dest);
    },
  },
};
</script>

<style scoped>
.menu {
  z-index: 10;
  position: absolute;
  right: 0px;
  top: 0px;
  width: 50vh;
  max-width: 95%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
  transition: width 0.5s;
}
.leftborder {
  background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0) 0%,
    /* #192026 0%, */ #a63232 33.33%,
    #ffcc66 66.66%,
    #ffffff 100%
  );
  width: 5%;
}
.navholder {
  width: 95%;
  background-color: #fffffff0;
  display: flex;
  align-items: center;
  justify-content: center;
}
nav {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  transition: opacity 0.1s 0s ease-in-out;
}

.topspacer {
  width: 10vmin;
  height: 10vmin;
  max-width: 50px;
  max-height: 50px;
  margin-bottom: 2vh;
}
nav > h1 {
  font-weight: 500;
  font-size: 6vh;
  cursor: pointer;
  color: black;
  margin-bottom: 2vh;
  width: 100%;
}

nav > h2 {
  font-weight: 500;
  font-size: 4vh;
  cursor: pointer;
  color: black;

  width: 100%;
}
.hidden {
  opacity: 0;
}

.shadow {
  /* visibility: hidden; */
  z-index: 9;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  background-color: #000000a0;
  backdrop-filter: blur(1vmin);
  cursor: pointer;
}

.nowidth {
  width: 0px;
}

.menubtn {
  z-index: 110;
  position: absolute;
  top: 1vmin;
  right: 1vmin;
  display: flex;
  align-items: center;
  justify-content: center;
  stroke: white;
  mix-blend-mode: difference;
  /* opacity: 80%; */
}

.disappear {
  opacity: 0;
}

.reallygone {
  display: none;
}

.fadein {
  transition: opacity 0.25s 0.5s ease-in-out;
}
</style>